/* eslint-disable */
import React, { useState, useEffect } from "react";
import { Modal, Stack, Textarea, Group, Button } from "@mantine/core";
import { IconX, IconArrowBack } from "@tabler/icons-react";
import { useCancelMeeting } from "api/meeting/cancelMeeting";

interface CancelMeetingModalProps {
  opened: boolean;
  onClose: () => void;
  currentMeetingId?: string | null;
  initialReason?: string;
  submitting?: boolean;
}

export default function CancelMeetingModal({
  opened,
  onClose,
  currentMeetingId,
  initialReason = "",
  submitting = false,
}: CancelMeetingModalProps) {
  const [reason, setReason] = useState<string>(initialReason);
  const { mutate: cancelMeetingMutate, isLoading } = useCancelMeeting();

  useEffect(() => {
    setReason(initialReason ?? "");
  }, [initialReason, opened]);

  function handleConfirm() {
    cancelMeetingMutate({
      meetingId: currentMeetingId!,
      payload: { reason: reason },
    });
    onClose();
  }

  return (
    <Modal opened={opened} onClose={onClose} title="Cancel Meeting">
      <Stack>
        <Textarea
          placeholder="Reason for cancellation (optional)"
          minRows={3}
          value={reason}
          onChange={(e) => setReason(e.currentTarget.value)}
        />

        <Group position="center">
          <Button
            onClick={handleConfirm}
            leftIcon={<IconX />}
            loading={submitting}
          >
            Confirm Cancel
          </Button>

          <Button
            variant="outline"
            onClick={onClose}
            leftIcon={<IconArrowBack />}
          >
            Go Back
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
